import { useMemo } from 'react'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { dateISOToDateAndTime } from 'Data/format.js'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index.js'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index.js'
import Procedure from './Procedure/index.js'
// Note: the views have to be inside Procedure so that viewPath matches the code structure
// otherwise it throws an invalid-view error
import ActionsAction from './Procedure/ActionsAction/index.js'
import Name from './Procedure/Name/index.js'
import Description from './Procedure/Description/index.js'
import RequiresDiagnosis from './Procedure/RequiresDiagnosis/index.js'
import RequiresImages from './Procedure/RequiresImages/index.js'
import View from './view.js'

export default function Logic(props) {
  let procedures = useDataValue({
    context: 'procedures',
    viewPath: props.viewPath,
  })
  let procedure_ids = useDataValue({
    context: 'selected',
    path: 'procedure_ids',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  let tableData = useMemo(
    () => ({
      columns: [
        {
          header: '',
          accessorKey: 'id',
          cell: cell => (
            <TysiaCheckbox
              onChange={value => {
                change(next => {
                  if (value) {
                    next.procedure_ids.push(cell.getValue())
                  } else {
                    next.procedure_ids = next.procedure_ids.filter(
                      item => item !== cell.getValue()
                    )
                  }
                })
              }}
              value={procedure_ids.includes(cell.getValue())}
              viewPath={props.viewPath}
            >
              {childProps => <TysiaCheckboxInput {...childProps} />}
            </TysiaCheckbox>
          ),
        },
        {
          header: 'Name',
          accessorKey: 'name',
          cell: cell => (
            <Name
              data={cell.row.original}
              viewPath={`${props.viewPath}/Procedure(${cell.row.original.id})/Name`}
            />
          ),
        },
        {
          header: 'Description',
          accessorKey: 'description',
          cell: cell => (
            <Description
              data={cell.row.original}
              viewPath={`${props.viewPath}/Procedure(${cell.row.original.id})/Description`}
            />
          ),
        },
        {
          header: 'Requires diagnosis',
          accessorKey: 'requires_diagnosis',
          cell: cell => (
            <RequiresDiagnosis
              data={cell.row.original}
              viewPath={`${props.viewPath}/Procedure(${cell.row.original.id})/RequiresDiagnosis`}
            />
          ),
        },
        {
          header: 'Requires images',
          accessorKey: 'requires_images',
          cell: cell => (
            <RequiresImages
              data={cell.row.original}
              viewPath={`${props.viewPath}/Procedure(${cell.row.original.id})/RequiresImages`}
            />
          ),
        },
        {
          header: 'Last edit',
          accessorKey: 'sys_last_modified',
          cell: cell => dateISOToDateAndTime(cell.getValue()),
        },
        {
          header: '',
          accessorKey: 'organization_id',
          cell: cell => (
            <ActionsAction
              data={cell.row.original}
              viewPath={`${props.viewPath}/Procedure(${cell.row.original.id})/ActionsAction`}
            />
          ),
        },
      ],
      data: procedures ?? [],
    }),
    [procedures, procedure_ids, props.viewPath, change]
  )

  function onRowClick(row) {
    setFlowTo(
      normalizePath(
        props.viewPath,
        `Procedure(${row.original.id})/ActionsAction/Edit/Content`
      )
    )
  }

  return (
    <View
      viewPath={props.viewPath}
      tableData={tableData}
      renderRow={Procedure}
      getRowViewPath={({ data }) => `${props.viewPath}/Procedure(${data.id})`}
      onRowClick={onRowClick}
    />
  )
}
